<template>
  <RowItemAligned
    class="row-item"
    :labels="batteryStorageLabels"
    :values="batteryStorageValues"
    :editable="true"
    last
    @edit="
      $emit('edit-component', {
        component: 'BatteryStorageEditComponent',
        location: 'technicalDetailsComponent',
        properties: {
          batteryStorageData,
          deviceUuid,
        },
      })
    "
  />
</template>

<script>
import RowItemAligned from './RowItemAligned';

export default {
  name: 'BatteryStorageSpecialData',
  props: {
    batteryStorageData: {
      type: Object,
      required: true,
    },
    deviceUuid: {
      type: String,
      required: true,
    },
  },
  components: {
    RowItemAligned,
  },
  computed: {
    batteryStorageLabels() {
      const data = this.batteryStorageData;
      if (!data) return ['-'];

      const labels = [];

      // Anzahl der Speichereinheiten
      if (data.number_of_storage_units !== undefined) {
        labels.push(
          this.$t('consumption_devices.order_details.number_of_storage_units')
        );
      }

      // Speicherbeladung
      if (data.storage_charging) {
        labels.push(
          this.$t('consumption_devices.order_details.storage_charging')
        );
      }

      // Speicherentladung
      if (data.storage_discharging) {
        labels.push(
          this.$t('consumption_devices.order_details.storage_discharging')
        );
      }

      // Speicherkapazität
      if (data.storage_capacity_Wh !== undefined) {
        labels.push(
          this.$t('consumption_devices.order_details.storage_capacity')
        );
      }

      // Einheitenzertifikat
      labels.push(
        this.$t('consumption_devices.order_details.unit_certificate')
      );

      return labels;
    },

    batteryStorageValues() {
      const data = this.batteryStorageData;
      if (!data) return ['-'];

      const values = [];

      // Anzahl der Speichereinheiten
      if (data.number_of_storage_units !== undefined) {
        values.push(data.number_of_storage_units);
      }

      // Speicherbeladung
      if (data.storage_charging) {
        values.push(
          this.$t(`consumption_devices.order_details.${data.storage_charging}`)
        );
      }

      // Speicherentladung
      if (data.storage_discharging) {
        values.push(
          this.$t(
            `consumption_devices.order_details.${data.storage_discharging}`
          )
        );
      }

      // Speicherkapazität (convert Wh to kWh)
      if (data.storage_capacity_Wh !== undefined) {
        const capacityKWh = data.storage_capacity_Wh / 1000;
        values.push(`${capacityKWh} kWh`);
      }

      // Einheitenzertifikat
      const certificateStatus = this.getCertificateStatus(
        data.unit_certificate
      );
      values.push(certificateStatus);

      return values;
    },
  },
  methods: {
    getCertificateStatus(unitCertificate) {
      // Check if certificate exists
      //TODO the mechanism of handeling the file must be revisited in the entire flow.
      if (
        unitCertificate &&
        (unitCertificate.file_name || unitCertificate.picture_name)
      ) {
        return this.$t(
          'consumption_devices.order_details.certificate_uploaded'
        );
      }
      return this.$t(
        'consumption_devices.order_details.certificate_not_uploaded'
      );
    },
  },
};
</script>

<style scoped>
.row-item {
  margin-block: 1px;
}
</style>
